export enum PaletteTypes {
    Lines = 'lines',
    Colors = 'colors',
    Points = 'points',
}
